import { render, staticRenderFns } from "./MassEditShortlists.vue?vue&type=template&id=473f8b85&"
import script from "./MassEditShortlists.vue?vue&type=script&lang=js&"
export * from "./MassEditShortlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports